import { render, staticRenderFns } from "./CDNSelect.vue?vue&type=template&id=82a8eda4&"
import script from "./CDNSelect.vue?vue&type=script&lang=js&"
export * from "./CDNSelect.vue?vue&type=script&lang=js&"
import style0 from "./CDNSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports